// Ice Cream Flavors card game data - ranked by popularity
export const ICE_CREAM_CARDS = [
  { id: 1, name: "Vanilla", rank: 1, image: "/images/iceCream/iceCream_1.jpg" },
  { id: 2, name: "Chocolate", rank: 2, image: "/images/iceCream/iceCream_2.jpg" },
  { id: 3, name: "Cookies and Cream", rank: 3, image: "/images/iceCream/iceCream_3.jpg" },
  { id: 4, name: "Mint Chocolate Chip", rank: 4, image: "/images/iceCream/iceCream_4.jpg" },
  { id: 5, name: "Strawberry", rank: 5, image: "/images/iceCream/iceCream_5.jpg" },
  { id: 6, name: "Cookie Dough", rank: 6, image: "/images/iceCream/iceCream_6.jpg" },
  { id: 7, name: "Butter Pecan", rank: 7, image: "/images/iceCream/iceCream_7.jpg" },
  { id: 8, name: "Rocky Road", rank: 8, image: "/images/iceCream/iceCream_8.jpg" },
  { id: 9, name: "Chocolate Chip", rank: 9, image: "/images/iceCream/iceCream_9.jpg" },
  { id: 10, name: "Salted Caramel", rank: 10, image: "/images/iceCream/iceCream_10.jpg" },
  { id: 11, name: "Neapolitan", rank: 11, image: "/images/iceCream/iceCream_11.jpg" },
  { id: 12, name: "Coffee", rank: 12, image: "/images/iceCream/iceCream_12.jpg" },
  { id: 13, name: "Pistachio", rank: 13, image: "/images/iceCream/iceCream_13.jpg" },
  { id: 14, name: "Peanut Butter", rank: 14, image: "/images/iceCream/iceCream_14.jpg" },
  { id: 15, name: "Moose Tracks", rank: 15, image: "/images/iceCream/iceCream_15.jpg" },
  { id: 16, name: "Birthday Cake", rank: 16, image: "/images/iceCream/iceCream_16.jpg" },
  { id: 17, name: "Cherry Garcia", rank: 17, image: "/images/iceCream/iceCream_17.jpg" },
  { id: 18, name: "Dulce de Leche", rank: 18, image: "/images/iceCream/iceCream_18.jpg" },
  { id: 19, name: "Pralines and Cream", rank: 19, image: "/images/iceCream/iceCream_19.jpg" },
  { id: 20, name: "Mango", rank: 20, image: "/images/iceCream/iceCream_20.jpg" },
  { id: 21, name: "Rum Raisin", rank: 21, image: "/images/iceCream/iceCream_21.jpg" },
  { id: 22, name: "Banana", rank: 22, image: "/images/iceCream/iceCream_22.jpg" },
  { id: 23, name: "Black Cherry", rank: 23, image: "/images/iceCream/iceCream_23.jpg" },
  { id: 24, name: "Maple Walnut", rank: 24, image: "/images/iceCream/iceCream_24.jpg" },
  { id: 25, name: "Cotton Candy", rank: 25, image: "/images/iceCream/iceCream_25.jpg" },
  { id: 26, name: "Bubblegum", rank: 26, image: "/images/iceCream/iceCream_26.jpg" },
  { id: 27, name: "Lemon", rank: 27, image: "/images/iceCream/iceCream_27.jpg" },
  { id: 28, name: "Green Tea", rank: 28, image: "/images/iceCream/iceCream_28.jpg" },
  { id: 29, name: "Lavender", rank: 29, image: "/images/iceCream/iceCream_29.jpg" },
  { id: 30, name: "Superman", rank: 30, image: "/images/iceCream/iceCream_30.jpg" }
];
